import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services';
import { environment } from './../../../environments/environment';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { config, CognitoIdentityCredentials, CognitoIdentityServiceProvider } from 'aws-sdk'
import { DialogService } from '../../services/dialog/dialog.service';
import { ChangePasswordChallengeComponent } from '../change-password-challenge/change-password-challenge.component';
import { COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION, COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION, COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION, COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION } from '../../utils/constant';
import { LanguageService } from 'src/app/services/language/language.service';
import * as _ from 'lodash';
import { NoWhiteSpaceValidator } from '../../utils/validators/nowhitespace.validator';

@Component({
  selector: 'esc-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm : FormGroup;
  isSubmitting : boolean;
  errorMessage: string;
  public imgUrl;
  constructor(
    private fb: FormBuilder, 
    public authService: AuthService,
    private dialogService: DialogService,
    private route: ActivatedRoute, 
    private router: Router
  ){ }

  ngOnInit() {
    this.forgotPasswordForm = this.fb.group({
      username: [null, [Validators.required, NoWhiteSpaceValidator]]
    });
    this.route.queryParams.subscribe(params => {
      if(params['username']){
        this.forgotPasswordForm.controls['username'].setValue(_.toLower(params['username']));
      }
    });

    this.imgUrl = 'assets/images/boc-logo.png';
  }

  onSubmit(value: any){
    this.isSubmitting = true;
    this.errorMessage = null;
    let username = _.toLower(_.trim(value['username']));

    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.authService.userPool
    });

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        this.isSubmitting = false;
        this.router.navigateByUrl("/reset-password?username=" + username);
      },
      onFailure: (err) => {
        this.isSubmitting = false;
        if(!environment.production) {
          console.log(err);
        }
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          return this.forgotPasswordForm.controls['username'].setErrors({
            "notExisting": true
          });
        }
        this.errorMessage = err.message;
      }
    });

    // this.cognitoService.forgotPassword(_.toLower(value['username']), function(err, result){
    //   self.isSubmitting = false;
    //   if(err){
    //     if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
    //       return self.forgotPasswordForm.controls['username'].setErrors({
    //         "notExisting": true
    //       });
    //     }
    //     return self.dialogService.confirm({
    //       title: "Forgot Password Failed", 
    //       message: err.message,
    //       button: "Close",
    //       hasCancel: false
    //     });
    //   }

    //   self.dialogService.confirm({
    //     title: "Verification Code Sent", 
    //     message: "Please check your username for verification code",
    //     button: "Close",
    //     hasCancel: false
    //   }).subscribe(res => {
    //     self.router.navigateByUrl("/reset-password?username=" + value['username']);
    //   });
    // });
  }

}
